export var PLSuccessPDefaultValues = {
    successHeaderDesktop: 'Pickup Scheduled!',
    successSubHeaderDesktop: 'You’ll receive an email confirmation and a text message reminder on the day of your pickup',
    successHeaderMobile: 'Pickup Scheduled!',
    successSubHeaderMobile: 'You’ll receive an email confirmation and a text message reminder on the day of your pickup',
    successButton: 'View Tracking',
};
//# sourceMappingURL=PLSuccessPDefaultValues.js.map